import {Component, OnInit} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";
import {DtoManagementSue} from "./models/DtoManagementSue";
import {MarketingInfoService} from "./marketing-info.service";
import {Border, SeriesLabels} from "@progress/kendo-angular-charts";

@Component({
    selector: 'app-sue-info',
    template: require('./marketing-info.component.html'),
    styles: [require('./marketing-info.component.css')]
})

@AutoUnsubscribe()
export class MarketingInfoComponent implements OnInit {
    periodDisabled: boolean;
    data: DtoManagementSue;
    filterHeaderConfig: PageHeaderBarConfig;
    years: Array<{ text: string, value: number }> = [];
    branches: DtoBranchUser[];
    filterForm: FormGroup;
    pshbConfigEmail: PageSubheaderBarConfig;
    pshbConfigMobileNo: PageSubheaderBarConfig;
    pshbConfigBirthdate: PageSubheaderBarConfig;
    pshbConfigEvents: PageSubheaderBarConfig;
    pshbConfigFeedback: PageSubheaderBarConfig;
    pshbConfigFeedbackDetails: PageSubheaderBarConfig;
    legendBorder: Border = {
        color: '#bababa',
        dashType: "solid",
        width: 1
    };
    feedbackLabels: SeriesLabels = {
        visible: true,
        padding: 3,
        font: '12px Arial, sans-serif',
        content: e => {return (e.percentage * 100).toFixed(0) + '%'}
    };


    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ss: SharedService,
                private sds: SharedDataService,
                private ds: MarketingInfoService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'marketing', isLastStep: false },
            { text: 'detailgegevens marketing', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'INSTELLINGEN',
            buttonDefinition: [
                {
                    description: 'RESULTATEN',
                    clickEventType: 'search',
                    isSmall: false
                }
            ]
        };

        this.pshbConfigEmail = {
            title: 'E-MAILADRES GEVULD',
            buttonDefinition: []
        };
        this.pshbConfigMobileNo = {
            title: 'MOBIELNUMMER GEVULD',
            buttonDefinition: []
        };
        this.pshbConfigBirthdate = {
            title: 'VERJAARDAG GEVULD',
            buttonDefinition: []
        };
        this.pshbConfigEvents = {
            title: 'VERSTUURDE BERICHTEN',
            buttonDefinition: []
        };
        this.pshbConfigFeedback = {
            title: 'FEEDBACK',
            buttonDefinition: []
        };
        this.pshbConfigFeedbackDetails = {
            title: 'FEEDBACK DETAILS',
            buttonDefinition: []
        };


        for (let i = 0; i < 5; i++) {
            this.years.push({
                text: (this.ss.getCurrentYear() - i).toString(),
                value: this.ss.getCurrentYear() - i
            });
        }

        this.filterForm = this.fb.group({
            year: this.ss.getCurrentYear(),
            userId: 0
        });

        this.filterForm.get('year').valueChanges.subscribe(newVal => {
            this.loadData();
        });

        this.filterForm.get('userId').valueChanges.subscribe(newVal => {
            this.loadData();
        });

        this.sds.getBranchesWithAll().subscribe((res: DtoBranchUser[]) => {
            this.branches = res;
            this.loadData();
        });
    }

    loadData() {
        this.data = null;
        this.ds.getSueInfo({
            userId: this.filterForm.get('userId').value,
            year: this.filterForm.get('year').value
        }).subscribe((res: DtoManagementSue) => {
            this.data = res;
        });
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/marketing/marketing-info/marketing-info.component.ts